import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";
import Fifth from "./Fifth_section/Fifth";
import Sixth from "./Sixth_section/Sixth";
import Third from "./Third_section/Third";
import Fourth from "./Fourth_section/Fourth";
import Nineth from "./Nineth_section/Nineth";
import Seventh from "./Seventh_section/Seventh";
import Eighth from "./Eighth_section/Eighth";

const Ai = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <Fourth />
      <Fifth />
      <Sixth />
      <Seventh />
      <Eighth />
      <Nineth />
      <Footer />
    </>
  );
};

export default Ai;
